module.exports = __webpack_public_path__ + "img/hd-upscale.03fb1faf.webp";